import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "link"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  confirm() {
    this.linkTarget.click()
  }

  // Close on backdrop click
  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
